import Service from "../../service/index";

const Common = {
    namespaced: true,
    state: {
        provinces: [],
        districts: [],
        sub_districts: [],
        all_districts: [],
        all_sub_districts: [],
        provincesdie: [],
        districtsdie: [],
        sub_districtsdie: [],
        type_water: [],
        departments: [],
        province_patient:[],
        nations_code:[],
    },
    mutations: {
        GET_PROVINCES: (state, data) => {
            state.provinces = data;
        },
        GET_PROVINCES_PATIENT: (state, data) => {
        state.province_patient = data;
        },
        GET_DISTRICTS: (state, data) => {
            state.districts = data;
        },
        GET_SUB_DISTRICTS: (state, data) => {
            state.sub_districts = data;
        },
        GET_PROVINCESDIE: (state, data) => {
            state.provincesdie = data;
        },
        GET_DISTRICTSDIE: (state, data) => {
            state.districtsdie = data;
        },
        GET_SUB_DISTRICTSDIE: (state, data) => {
            state.sub_districtsdie = data;
        },
        GET_ALLDISTRICTS: (state,data) => {
            state.all_districts = data;
        },
        GET_ALLSUBDISTRICTS: (state,data) => {
            state.all_sub_districts = data;
        }

    },
    actions: {
        setProvince({commit}){
            return Service.Common.getProvince()
                .then(data=>{
                    commit("GET_PROVINCES",data);
                })
        },
        setProvincedie({commit}){
            return Service.Common.getProvince()
                .then(data=>{
                    commit("GET_PROVINCESDIE",data);
                })
        },
        setAllDistricts({commit}){
            return Service.Common.getAllDistricts()
                .then(data=>{
                    commit("GET_ALLDISTRICTS",data)
                })
        },
        setAllSubDistricts({commit}){
            return Service.Common.getAllSubDistricts()
                .then(data=>{
                    commit("GET_ALLSUBDISTRICTS",data)
                })
        },
        setDistrict({commit},province_id){
            return Service.Common.getDistrict(province_id)
                .then(data=>{
                    commit("GET_DISTRICTS",data);

                })
        },
        setDistrictdie({commit},province_id){
            return Service.Common.getDistrict(province_id)
                .then(data=>{
                    commit("GET_DISTRICTSDIE",data);

                })
        },
        setSubDistrict({commit},district_id){
            return Service.Common.getSubDistrict(district_id)
                .then(data=>{
                    commit("GET_SUB_DISTRICTS",data);
                })
        },
        setSubDistrictdie({commit},district_id){
            return Service.Common.getSubDistrict(district_id)
                .then(data=>{
                    commit("GET_SUB_DISTRICTSDIE",data);
                })
        },
        setTypeWater({commit}){
            return Service.Common.getTypeWater()
                .then(data=>{
                    commit("GET_TYPE_WATER",data);
                })
        },
        setDepartments({commit}){
            return Service.Common.getDepartments()
                .then(data=>{
                    commit("GET_DEPARTMENTS",data);
                })
        },
      setProvincePatient({commit}){
        return Service.Common.getProvincePatient()
          .then(data=>{
            commit("GET_PROVINCES_PATIENT",data);
          })
      },
      setNation({commit}){
        return Service.Common.getNation()
          .then(data=>{
            commit("GET_NATION",data);
          })
      },

    }
};

export default Common;
